import { render, staticRenderFns } from "./coupon-package.vue?vue&type=template&id=a4c05aa2&scoped=true"
import script from "./coupon-package.vue?vue&type=script&lang=js"
export * from "./coupon-package.vue?vue&type=script&lang=js"
import style0 from "./coupon-package.vue?vue&type=style&index=0&id=a4c05aa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.38_cache-loader@4.1.0_webpack@4.47.0__css-load_8b2b7732cc741d077553b84f33555b65/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c05aa2",
  null
  
)

export default component.exports